module.exports = __webpack_public_path__ + "img/logo-devto.e45dab88.svg";